import {
	BaseError,
} from './BaseError';

export class GetSpecificationsError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
